import {ActivityJournals} from './ActivityJournals';
export default ActivityJournals;
